import { getProductPricing } from "../utils/productPricing";

const canTrack = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

const normalizeValue = (value) =>
  value === undefined || value === null || Number.isNaN(value) ? undefined : value;

export const trackEvent = (eventName, params = {}) => {
  if (!canTrack()) return;

  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined)
  );

  window.gtag("event", eventName, cleanParams);
};

export const trackPageView = ({ path, title, location } = {}) => {
  if (!canTrack()) return;

  window.gtag("event", "page_view", {
    page_path: path || window.location.pathname + window.location.search,
    page_title: title || document.title,
    page_location: location || window.location.href,
  });
};

export const trackAddToCart = (product, quantity = 1) => {
  const { effectivePrice } = getProductPricing(product);
  trackEvent("add_to_cart", {
    currency: "USD",
    value: normalizeValue(effectivePrice * quantity),
    items: [
      {
        item_id: String(product?.sku || product?.id || ""),
        item_name: product?.name,
        item_category: product?.mainCategories || product?.category,
        item_variant: product?.selectedColor?.name,
        price: normalizeValue(effectivePrice),
        quantity,
      },
    ],
  });
};

export const trackViewItem = (product) => {
  const { effectivePrice } = getProductPricing(product);
  trackEvent("view_item", {
    currency: "USD",
    value: normalizeValue(effectivePrice),
    items: [
      {
        item_id: String(product?.sku || product?.id || ""),
        item_name: product?.name,
        item_category: product?.mainCategories || product?.category,
        price: normalizeValue(effectivePrice),
      },
    ],
  });
};

export const trackGenerateLead = ({ formName, value } = {}) => {
  trackEvent("generate_lead", {
    currency: value ? "USD" : undefined,
    value: normalizeValue(value),
    form_name: formName,
  });
};

export const trackLogin = (method = "password") => {
  trackEvent("login", { method });
};

export const trackSignUp = (method = "password") => {
  trackEvent("sign_up", { method });
};
